import React, { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import actions from 'state/actions';
import styled from 'styled-components/macro';
import utils from 'utils';

import CommonButton from '../Buttons/CommonButton';

const StyledFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  padding: 0 5px;
  > * {
    margin: 5px;
  }
  [type='submit']:focus {
    border: 2px solid #000;
  }
`;

interface Props {
  withConfirmButton?: boolean;
  confirmAction?: Function;
  dontCloseOnConfirm?: boolean;
  cancelAction?: Function;
  confirmText?: string;
  confirmDisabled?: boolean;
  withCloseButton?: boolean;
  closeButtonText?: string;
  closeDisabled?: boolean;
  scopeSecondary?: 'primary' | 'secondary' | 'tertiary' | 'quaternary';
}

const Footer: FunctionComponent<Props> = (props) => {
  const dispatch = useDispatch();
  const t = utils.intl.useTranslator();
  const notification = utils.app.notify;
  const {
    withConfirmButton = true,
    confirmText,
    confirmDisabled,
    children,
    withCloseButton = true,
    dontCloseOnConfirm = false,
    closeButtonText,
    confirmAction,
    cancelAction,
    closeDisabled,
  } = props;

  const handleClose = () => {
    cancelAction?.();
    dispatch(actions.modal.closeModal());
  };

  const handleConfirm = async () => {
    try {
      await confirmAction?.();
      !dontCloseOnConfirm && dispatch(actions.modal.closeModal());
    } catch (error) {
      console.error(error);
      notification('fail', t(error as string));
    }
  };

  return (
    <StyledFooter className="modalFooter">
      {withConfirmButton && (
        <CommonButton
          id="confirm"
          disabled={confirmDisabled}
          action={handleConfirm}
          value={confirmText || t('confirm')}
          type="submit"
        />
      )}
      {withCloseButton && (
        <CommonButton
          id="cancel"
          scope={props.scopeSecondary ?? 'secondary'}
          action={handleClose}
          value={closeButtonText || t('cancel')}
          type="submit"
          disabled={closeDisabled}
        />
      )}
      {children}
    </StyledFooter>
  );
};

export default Footer;
